import { MyleTabKey } from "../enums/MyleTabKey";

/**
 * A lookup used by the NavStore to match paths to tabs.
 */
class MyleMenuNavPathLookup {
    // ensures naming convention matches the name of the variable and not the string value in NavStore.
    public static MyleTab: string = MyleTabKey.Myle;
    public static AdministrationTab: string = MyleTabKey.Admin;
    public static CalendarTab: string = MyleTabKey.Calendar;
    public static PatientsTab: string = MyleTabKey.Patients;
    public static CommunicationsTab: string = MyleTabKey.Communications;
    public static Communications_optimizedv2Tab: string = MyleTabKey.Communications;
    public static DocumentsTab: string = MyleTabKey.Documents;
    public static BillingTab: string = MyleTabKey.Billing;
    public static SchedulingTab: string = MyleTabKey.Scheduling;
    public static ResultsTab: string = MyleTabKey.LabResults;
    public static ListsTab: string = MyleTabKey.Lists;
    public static PortfolioTab: string = MyleTabKey.Portfolio;
    public static ReportingTab: string = MyleTabKey.Reporting;
    public static SettingsTab: string = MyleTabKey.Scheduling;
    public static AffectationTab: string = MyleTabKey.Scheduling;
    public static LabsTab: string = MyleTabKey.LabResults;
    public static BillingCostTab: string = MyleTabKey.Billing;
    public static PrescriptionrenewalsTab: string = MyleTabKey.PrescriptionRenewals;
    public static readonly PharmacyOrdersTab: string = MyleTabKey.PharmacyOrders;
}

export { MyleMenuNavPathLookup };
